module.exports = __webpack_public_path__ + "img/mail.43e90e50.svg";